import {combineReducers} from '@reduxjs/toolkit'
import userReducer, {logoutSuccess} from './userSlice'
import notificationsReducer from './notificationsSlice'
import {buildObjectWithSpecificKeys} from 'utils/object'
import instanceModalReducer from './instanceModalSlice'
//1ra Api
import {
  reducerPath as apiSlicePath,
  reducer as apiSliceReducer,
} from '../apiSlices/apiSlice'

//2ra Api
 import {
  reducerPath as ocaApiSlicePath,
  reducer as ocaApiSliceReducer,
 } from '../apiSlices/ocaApiSlice'

//3ra Api
 import {
  reducerPath as cuadrillaApiSlicePath,
  reducer as cuadrillaApiSliceReducer,
 } from '../apiSlices/cuadrillaApiSlice'
 
 //4ra Api
 import {
  reducerPath as checkListApiSlicePath,
  reducer as checkListApiSliceReducer,
 } from '../apiSlices/checkListApiSlice'
 
// Redux: Root Reducer
const reducer = combineReducers({
  user: userReducer,
  notifications: notificationsReducer,
  instanceModal: instanceModalReducer,
  [apiSlicePath]: apiSliceReducer,
  [ocaApiSlicePath]: ocaApiSliceReducer,
  [cuadrillaApiSlicePath]: cuadrillaApiSliceReducer,
  [checkListApiSlicePath]: checkListApiSliceReducer,
})

// Destroy redux state
const rootReducer = (state, action) => {
  if (action.type === logoutSuccess.type) {
    const config = buildObjectWithSpecificKeys(state, ['notifications.snackBars'])
    state = config
  }
  return reducer(state, action)
}

// Exports
export default rootReducer
